import React from "react";
import PropTypes from "prop-types";
import {
  CURRENTLY_REPAIRING_STATUSES,
  CURRENTLY_TRANSFERRING_STATUSES,
  CORE_RETURNED_TO_CUSTOMER,
  DISCREPANCY_REPORTED,
  IN_STOCK,
  GONE,
  REPAIRING,
  REPAIR_STATUSES,
  STATUSES,
  REPAIR_AND_HOLD,
  RESERVE_FOR_SALE,
  SALES_ORDER_CREATED,
  VENDOR_RMA_REQUESTED
} from "MODULES/inventories/constants";

const labelStyle = status => {
  if (status === IN_STOCK) {
    return { color: "#4caf50" };
  }
  return {};
};

const icon = status => {
  if (status === IN_STOCK) {
    return <i className="fa fa-check" />;
  }
  return null;
};

const UNIFIED_INVENTORY_STATUSES = Object.assign({}, STATUSES, REPAIR_STATUSES);

const formatRepairAndHold = items =>
  items[0].repair_and_hold_lead_time === 0
    ? "Repair & Hold"
    : `Repair & Hold - LT (${items[0].repair_and_hold_lead_time} days)`;

const getDisplayStatus = ({
  inventoryStatus,
  repairStatus,
  transferStatus
}) => {
  if (
    (CURRENTLY_REPAIRING_STATUSES[repairStatus] &&
      ![
        DISCREPANCY_REPORTED,
        GONE,
        RESERVE_FOR_SALE,
        SALES_ORDER_CREATED,
        VENDOR_RMA_REQUESTED
      ].includes(inventoryStatus)) ||
    repairStatus === CORE_RETURNED_TO_CUSTOMER
  ) {
    return repairStatus;
  } else if (
    inventoryStatus === IN_STOCK &&
    CURRENTLY_TRANSFERRING_STATUSES.includes(transferStatus)
  ) {
    return transferStatus;
  }

  return inventoryStatus;
};

export default function InventoryStatusLabel({
  inventory: {
    status: inventoryStatus,
    repair_status: repairStatus,
    repair_order_line_items: repairOrderLineItems,
    transfer_status: transferStatus
  }
}) {
  const status = getDisplayStatus({
    inventoryStatus,
    repairStatus,
    transferStatus
  });

  if (
    repairStatus === REPAIR_AND_HOLD &&
    [REPAIRING, IN_STOCK].includes(inventoryStatus)
  ) {
    return <span>{formatRepairAndHold(repairOrderLineItems)}</span>;
  }

  return (
    <span style={labelStyle(status)}>
      {icon(status)} {UNIFIED_INVENTORY_STATUSES[status].label}
    </span>
  );
}

InventoryStatusLabel.propTypes = {
  inventory: PropTypes.instanceOf(Object)
};



// WEBPACK FOOTER //
// ./app/modules/inventories/components/Detail/InventoryStatusLabel.jsx